export enum EType {
  boolean = "boolean",
  function = "function",
  number = "number",
  object = "object",
  string = "string",
  symbol = "symbol",
  undefined = "undefined"
}